import React from "react";

import { AccordionProps } from "@mui/material";

import { AccordionTag } from "./styles";

interface AccordionRootProps extends AccordionProps {
  children: NonNullable<React.ReactNode>;
  hasError?: boolean;
}

export function AccordionRoot({
  children,
  hasError = false,
  expanded = false,
  ...rest
}: AccordionRootProps) {
  return (
    <AccordionTag.Wrapper hasError={hasError} expanded={expanded} {...rest}>
      {children}
    </AccordionTag.Wrapper>
  );
}
